import DatePickerComponent from "ui/Date";
import { FC, useRef, useState } from "react";
import { getSpecies } from "api/common";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { StorageStatisticFilter } from "api/sales";

interface CustomProps {
	setFilterOptions: (options: StorageStatisticFilter) => void;
	filterOptions: StorageStatisticFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [localFromDate, setLocalFromDate] = useState(filterOptions.fromDate);
	const [localToDate, setLocalToDate] = useState(filterOptions.toDate);
	const pendingFromDate = useRef(filterOptions.fromDate);
	const pendingToDate = useRef(filterOptions.toDate);

	const applyFromDate = () => {
		const newValue = pendingFromDate.current;
		if (newValue === filterOptions.fromDate) return;
		setFilterOptions({ ...filterOptions, fromDate: newValue });
	};

	const applyToDate = () => {
		const newValue = pendingToDate.current;
		if (newValue === filterOptions.toDate) return;
		setFilterOptions({ ...filterOptions, toDate: newValue });
	};

	return (
		<div className="filter-container">
			<div className="filter-items store-statistics-filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localFromDate}
						onChange={(e) => {
							pendingFromDate.current = e.target.value;
							setLocalFromDate(e.target.value);
						}}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localToDate}
						onChange={(e) => {
							pendingToDate.current = e.target.value;
							setLocalToDate(e.target.value);
						}}
						onBlur={() => applyToDate()}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(species) =>
							setFilterOptions({
								...filterOptions,
								speciesCode: species.code,
								species: species.name,
							})
						}
						label={t("Species")}
						value={{
							code: filterOptions.speciesCode || null,
							name: filterOptions.species || " ",
						}}
						dataItemKey="code"
						textField="name"
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getSpecies}
						className="height-inherit"
						popupSettings={{ width: 400 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn store-statistics-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
